import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Submit/PASSWORD_ERROR',
    PENDING: 'Submit/PASSWORD_PENDING',
    SUCCESS: 'Submit/PASSWORD_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
